import { RestApi } from "../services/rest-api";
import { YesNo } from "../types/yes-no.type";

export interface BrandModel {
  id?: number;
  brand_name: string;
  publish: YesNo;
}

export const fetchBrandList = async (authInfo: any) => {
  return await RestApi<Array<BrandModel>>('post', 'brandList', {}, authInfo.user.authorization).then(function (response) {
    return response;
  });
};

export const deleteBrand = async (id: number, authInfo: any) => {
  return await RestApi<any>('post', 'deleteBrand', { id }, authInfo.user.authorization).then(function (response) {
    return response;
  });
};

